export default __webpack_public_path__ + "images/Biparietal_Diameter_blue.f0464889aa5e87637bb5c980abe237ce.png";